import React, { useState } from "react";
import { FiFilter, FiCheckCircle, FiClock } from "react-icons/fi";
import { SeverityBadge, StatusBadge, severityColor, severityBg } from "./waterHelpers";

const CATEGORIES = ["All", "Overflow", "Leakage", "Low Tank", "Pump Health", "High Usage", "Supply", "Pump"];
const SEVERITIES = ["All", "Critical", "Warning", "Info"];

const STATUS_DOT = {
  "Open":          "#ef4444",
  "Investigating": "#f59e0b",
  "Action Taken":  "#3b82f6",
  "Scheduled":     "#8b5cf6",
  "Notified":      "#06b6d4",
  "Closed":        "#10b981",
};

const WmAlertsPanel = ({ d }) => {
  const [catFilter, setCatFilter] = useState("All");
  const [sevFilter, setSevFilter] = useState("All");
  const [selected, setSelected] = useState(null);

  const filtered = d.alerts.filter(a =>
    (catFilter === "All" || a.category === catFilter) &&
    (sevFilter === "All" || a.severity === sevFilter)
  );

  const sel = selected ? d.alerts.find(a => a.id === selected) : null;

  return (
    <div className="wm-alerts">

      {/* ── Count Chips ── */}
      <div className="wa-count-row">
        {["Critical", "Warning", "Info"].map(sev => (
          <div key={sev} className="wa-count-chip" style={{ background: severityBg(sev), borderColor: severityColor(sev) }}>
            <span className="wa-count-num" style={{ color: severityColor(sev) }}>
              {d.alerts.filter(a => a.severity === sev).length}
            </span>
            <span style={{ color: severityColor(sev), fontSize: "0.78rem" }}>{sev}</span>
          </div>
        ))}
        <div className="wa-count-chip" style={{ background: "#f1f5f9" }}>
          <span className="wa-count-num">{d.alerts.filter(a => a.status === "Closed").length}</span>
          <span style={{ fontSize: "0.78rem", color: "#64748b" }}>Resolved</span>
        </div>
      </div>

      {/* ── Filters ── */}
      <div className="wa-filter-row">
        <FiFilter size={14} color="#94a3b8" />
        <div className="wa-filter-group">
          {SEVERITIES.map(s => (
            <button key={s} className={`wa-filter-btn ${sevFilter === s ? "wa-filter-active" : ""}`}
              style={sevFilter === s && s !== "All" ? { background: severityBg(s), color: severityColor(s), borderColor: severityColor(s) } : {}}
              onClick={() => setSevFilter(s)}>
              {s}
            </button>
          ))}
        </div>
        <span style={{ color: "#e2e8f0" }}>|</span>
        <div className="wa-filter-group">
          {CATEGORIES.map(c => (
            <button key={c} className={`wa-filter-btn ${catFilter === c ? "wa-filter-active" : ""}`} onClick={() => setCatFilter(c)}>
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="wa-layout">

        {/* ── Alert List ── */}
        <div className="wa-list">
          {filtered.map(a => (
            <div
              key={a.id}
              className={`wa-alert-card ${selected === a.id ? "wa-alert-active" : ""}`}
              style={{ borderLeftColor: severityColor(a.severity) }}
              onClick={() => setSelected(selected === a.id ? null : a.id)}
            >
              <div className="wa-alert-header">
                <div className="wa-alert-dot" style={{ background: severityColor(a.severity) }} />
                <span className="wa-alert-category">{a.category}</span>
                <SeverityBadge severity={a.severity} />
                <span className="wa-alert-time"><FiClock size={11} /> {a.time}</span>
              </div>
              <div className="wa-alert-location">{a.location}</div>
              <div className="wa-alert-message">{a.message}</div>
              <div className="wa-alert-footer">
                <span className="wa-status-dot" style={{ background: STATUS_DOT[a.status] || "#94a3b8" }} />
                <span className="wa-alert-status">{a.status}</span>
                {a.assignee !== "—" && <span className="wa-alert-assignee">→ {a.assignee}</span>}
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="wa-empty"><FiCheckCircle size={32} color="#10b981" /><p>No alerts match the current filter</p></div>
          )}
        </div>

        {/* ── Detail ── */}
        <div className="wa-detail">
          {sel ? (
            <>
              <div className="wa-detail-title">{sel.category}</div>
              <div style={{ margin: "0.5rem 0" }}><SeverityBadge severity={sel.severity} /></div>
              <div className="wa-detail-grid">
                {[
                  ["Alert ID",   sel.id],
                  ["Location",   sel.location],
                  ["Time",       sel.time],
                  ["Status",     sel.status],
                  ["Assigned To",sel.assignee],
                ].map(([label, val]) => (
                  <div key={label} className="wa-dg-item">
                    <span className="wa-dg-label">{label}</span>
                    <span className="wa-dg-val" style={{ color: label === "Status" ? STATUS_DOT[val] : undefined }}>{val}</span>
                  </div>
                ))}
              </div>
              <div className="wa-detail-msg">{sel.message}</div>
              {sel.status === "Closed" && (
                <div className="wa-resolved-note"><FiCheckCircle size={14} color="#059669" /> This alert has been resolved.</div>
              )}
            </>
          ) : (
            <div className="wa-empty">
              <FiFilter size={36} color="#cbd5e1" />
              <p>Select an alert to view details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WmAlertsPanel;
